import {Component, Input} from '@angular/core';
import {Tendenz} from '../../../../../../../../../model/vorhersagen/pollenflug';

@Component({
  selector: 'app-pollenflug-tendenz',
  templateUrl: './pollenflug-tendenz.component.html',
  styleUrls: ['./pollenflug-tendenz.component.css']
})
export class PollenflugTendenzComponent {

  @Input()
  tendenz: Tendenz;

  determineIconName(tendenz: number): string {
    switch (tendenz) {
      case -1:
        return 'south_east';
      case 0:
        return 'east';
      case 1:
        return 'north_east';
      default:
        return 'help_outline';
    }
  }

}
